import create from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { DayTrade, SplitOrder, TradingFeatureEnum } from '../types/trading';
import { getTradingInfo } from '../api/trading';

interface State {
  dayTrade?: DayTrade;
  splitOrder?: SplitOrder;
  isLoading: boolean;
}

interface Actions {
  loadTradingInfo(features: TradingFeatureEnum[]): Promise<
    {
        day_trade?: DayTrade;
        split_order?: SplitOrder;
      }
  >;
}

const initialState: State = {
  dayTrade: undefined,
  splitOrder: undefined,
  isLoading: false,
};

export const useTradingInfoStore = create(
  immer<State & Actions>((set) => ({
    ...initialState,
    async loadTradingInfo(features = [TradingFeatureEnum.UNSPECIFIED]) {
      try {
        set((draft) => {
          draft.isLoading = true;
        });
        const response = await getTradingInfo(features);

        const { data } = response.data;

        set((draft) => {
          draft.isLoading = false;
          draft.dayTrade = data.day_trade ?? draft.dayTrade;
          draft.splitOrder = data.split_order ?? draft.splitOrder;
        });

        return data;
      } catch (error) {
        set((draft) => {
          draft.isLoading = false;
        });
        Promise.reject(error);

        return {
          day_trade: undefined,
          split_order: undefined,
        };
      }
    },
  })),
);
